module.exports = __webpack_public_path__ + "static/img/20.ad629602.png";